<template>
  <router-link
    :to="`${props.item.to}`"
    class="navItemLink rounded-md">
    <i class="navIcon">
      <IconSet :item="props.item.icon" />
    </i>
    <span>{{ props.item.title }}</span>
  </router-link>
</template>

<script lang="ts" setup>
import IconSet from '@/layout/horizontal-sidebar/IconSet.vue';
import type { Menu } from '@/layout/horizontal-sidebar/horizontalItems.ts';

const props = defineProps<{ item: Menu }>();
</script>
